import {useState, useEffect} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import LOGO from "../assets/media/Logo.svg";

export const Header: React.FC = () => {
    const [show, setShow] = useState(false);
    const [isHeaderVisible, setIsHeaderVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [isTransparent, setIsTransparent] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setIsTransparent(currentScrollY < 10);
            if (currentScrollY < 10) {
                setIsHeaderVisible(true);
            } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
                setIsHeaderVisible(false);
            } else if (currentScrollY < lastScrollY) {
                setIsHeaderVisible(true);
            }
            setLastScrollY(currentScrollY);
        };
        window.addEventListener("scroll", handleScroll, {passive: true});
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [lastScrollY]);

    const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
        e.preventDefault();
        handleClose();

        if (location.pathname !== "/") {
            // Navigate to home page without refresh
            navigate("/");
            // Scroll to section after navigation completes
            setTimeout(() => {
                const element = document.getElementById(sectionId);
                if (element) {
                    const headerOffset = 0;
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                    });
                }
            }, 100);
        } else {
            // Smooth scroll to section
            const element = document.getElementById(sectionId);
            if (element) {
                const headerOffset = 0;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        }
    };

    const navigationItems = [
        {sectionId: "home", label: "Home"},
        {sectionId: "features", label: "Features"},
        {sectionId: "about-us", label: "About Us"},
        {sectionId: "register-interest", label: "Register Interest"},
        {sectionId: "faq", label: "FAQ"},
        {sectionId: "contact-us", label: "Contact Us"},
    ];

    return (
        <header
            className={`wrapper ${isTransparent ? "transparent" : ""} ${
                isHeaderVisible ? "header-visible " : "header-hidden"
            }`}
        >
            <nav className="navbar navbar-expand-lg center-nav">
                <div className="container flex-lg-row flex-nowrap align-items-center">
                    <div className="navbar-brand w-100">
                        <Link to="/">
                            <img src={LOGO} className="logo" width="108" height="35" alt="logo" />
                        </Link>
                    </div>
                    <div
                        className={`navbar-collapse offcanvas offcanvas-nav offcanvas-start   ${show ? "show " : ""}`}
                        id="offcanvasNav"
                    >
                        <div className="offcanvas-header d-lg-none">
                            <Link to="/">
                                <img className="ms-4" src={LOGO} width="90" height="50" alt="logo" />
                            </Link>
                            <button
                                // type="button"
                                className="btn-close btn-close-white me-1 mb-4"
                                onClick={handleClose}
                                aria-label="Close"
                            ></button>
                        </div>

                        <div className="offcanvas-body ms-lg-auto d-flex flex-column h-100 justify-content-lg-end">
                            <ul className="navbar-nav">
                                {navigationItems.map((item) => (
                                    <li key={item.sectionId} className="nav-item">
                                        <Link
                                            className="nav-link"
                                            to={`/#${item.sectionId}`}
                                            onClick={(e) => handleNavClick(e, item.sectionId)}
                                        >
                                            {item.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="navbar-other d-flex ms-auto">
                        <ul className="navbar-nav flex-row align-items-center ms-auto">
                            <li className="nav-item d-lg-none">
                                <button
                                    className="hamburger offcanvas-nav-btn"
                                    onClick={handleShow}
                                    aria-label="Toggle navigation menu"
                                >
                                    <span></span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Header;
